import {Bom, BomState} from "@/modules/bom/types";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {getBoms, saveBoms} from "@/services/bom";

export const state: BomState = {
  bom: {
    valid_from: new Date(),
    valid_to: new Date()
  },
  boms: []
}

const actions: ActionTree<BomState, RootState> = {
  async GET_BOMS(_, id) {
    return await getBoms(id);
  },
  async SAVE_BOMS(_, boms) {
    return await saveBoms(boms);
  },
}

const mutations: MutationTree<BomState> = {
  SET_BOM(state, bom: Bom) {
    state.bom = bom;
  },
  SET_BOMS(state, boms: Bom[]) {
    state.boms = boms;
  },
  RESET_BOMS() {
    state.boms = [];
  }
}

const getters: GetterTree<BomState, RootState> = {
  BOM(state): Bom {
    const {bom} = state;
    return {...bom};
  },
  BOMS(state): Bom[] {
    const {boms} = state;
    return [...boms];
  }
}

export const bom: Module<BomState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
